import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.75",
      d: "m12 4.15 5.65 2.35v4.75c0 3.8-2.32 6.44-5.65 8.1-3.33-1.66-5.65-4.3-5.65-8.1V6.5L12 4.15Z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.75",
      d: "M12 8.5v4.2"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "12",
      cy: "15.35",
      r: ".95",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }